/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import Logger from "../lib/logger";

gsap.registerPlugin(ScrollToPlugin);
import ThemeHeader from "../partials/ThemeHeader";
import ScribbleIn from "../partials/ScribbleIn";
import FeatureSection from "../partials/FeatureSection";
import HeroWithIntro from "../partials/HeroWithIntro";
import CardCarousel from "../partials/CardCarousel";
import ImageGallery from "../partials/ImageGallery";
import PhotoCollage from "../partials/PhotoCollage";
import ScrollVideo from "../partials/ScrollVideo";
import VendorList from "../partials/VendorList";
import FaqAccordion from "../partials/FaqAccordion";
import SocialBanner from "../partials/SocialBanner";
import NeighborhoodEvents from "../partials/NeighborhoodEvents";
import CuratedSocialFeed from "../partials/CuratedSocialFeed";
import Developments from "../partials/Developments";
import BusinessMap from "../partials/BusinessMap";
import ImageCarousel from "../partials/ImageCarousel";
import PhotoMoment from "../partials/PhotoMoment";
import GradientHero from "../partials/GradientHero";
import TextTicker from "../partials/TextTicker";

export default function () {
	const NAME = 'Global';
	Logger.info(`${NAME} > loading`);

	function init() {
		Logger.info(`${NAME} > init`);

		const themeHeader = initThemeHeader();
		new ScribbleIn().init();
		new FeatureSection().init();

		const heroWithIntroDom = document.querySelector("[data-hero-with-intro]");
		if (heroWithIntroDom) {
			const heroWithIntro = new HeroWithIntro(heroWithIntroDom);
			if (themeHeader) heroWithIntro.on("done", () => themeHeader.revealIntro());
			heroWithIntro.init();
		}

		const cardCarouselDom = document.querySelector("[data-card-carousel]");
		if (cardCarouselDom) new CardCarousel(cardCarouselDom).init();

		const imageGalleryDom = document.querySelector("[data-image-gallery]");
		if (imageGalleryDom) new ImageGallery(imageGalleryDom).init();

		const photoCollageDom = document.querySelector("[data-photo-collage]");
		if (photoCollageDom) new PhotoCollage(photoCollageDom).init();

		const scrollVideoDom = document.querySelector("[data-scroll-video]");
		if (scrollVideoDom) new ScrollVideo(scrollVideoDom).init();

		document.querySelectorAll("[data-vendor-list]").forEach((el) => new VendorList(el).init());
		document.querySelectorAll("[data-faq-accordion]").forEach((el) => new FaqAccordion(el).init());
		document.querySelectorAll("[data-social-banner]").forEach((el) => new SocialBanner(el).init());
		document.querySelectorAll("[data-neighborhood-events]").forEach((el) => new NeighborhoodEvents(el).init());
		document.querySelectorAll("[data-curated-social-feed]").forEach((el) => new CuratedSocialFeed(el).init());

		if (document.querySelector("[data-developments]")) new Developments().init();

		const businessMapDom = document.querySelector("[data-business-map]");
		if (businessMapDom) new BusinessMap(businessMapDom).init();

		document.querySelectorAll("[data-image-carousel]").forEach((el) => new ImageCarousel(el).init());
		document.querySelectorAll("[data-photo-moment]").forEach((el) => new PhotoMoment(el).init());
		document.querySelectorAll("[data-gradient-hero]").forEach((el) => new GradientHero(el).init());
		document.querySelectorAll("[data-text-ticker]").forEach((el) => new TextTicker(el).init());
	}

	function initThemeHeader() {
		Logger.info(`${NAME} > initThemeHeader`);
		const themeHeaderDom = document.querySelector("[data-theme-header]");
		if (!themeHeaderDom) return null;
		const themeHeader = new ThemeHeader(themeHeaderDom);
		themeHeader.init();
		return themeHeader;
	}

	function initHashScroll() {
		const hash = window.location.hash;
		if (!hash) return;

		window.addEventListener('load', () => {
			const target = document.querySelector(hash);
			if (!target) return;
			gsap.to(window, { scrollTo: { y: target, offsetY: 0 }, duration: 0, delay: 0.1 });
		});
	}

	Logger.info(`${NAME} > loaded`);
	init();
	initHashScroll();
}
